// @flow

import React, { Component } from 'react';

import { Box, Icon, Image, Mask, Text } from 'gestalt';

type Props = {|
  name: string,
  selected: boolean,
  image: ?{
    height: number,
    url: string,
    width: number,
  },
  inFlyoutExp: ?boolean,
|};

type State = {|
  isHovering: boolean,
|};

export default class BoardSuggestionListRow extends Component<Props, State> {
  state: State = {
    isHovering: false,
  };

  onHover = () => {
    this.setState({ isHovering: true });
  };

  offHover = () => {
    this.setState({ isHovering: false });
  };

  render() {
    const { name, selected, image, inFlyoutExp } = this.props;

    if (inFlyoutExp) {
      return (
        /* eslint-disable jsx-a11y/mouse-events-have-key-events */
        <Box
          alignItems="center"
          color={this.state.isHovering ? 'lightGray' : 'transparent'}
          direction="row"
          display="flex"
          paddingX={4}
          paddingY={2}
          onMouseOver={this.onHover}
          onMouseOut={this.offHover}
        >
          {/* eslint-enable jsx-a11y/mouse-events-have-key-events */}
          <Box>
            <Mask height={40} width={40} shape="rounded">
              {this.state.isHovering && image ? (
                <Image
                  alt=""
                  color=""
                  fit="cover"
                  naturalHeight={image.height}
                  naturalWidth={image.width}
                  src={image.url}
                />
              ) : (
                <Box color={'lightGray'} height={40} width={40} />
              )}
            </Mask>
          </Box>
          <Box padding={2}>
            <Text size="xl" weight="bold">
              {name}
            </Text>
          </Box>
        </Box>
      );
    } else {
      return (
        <Box
          alignItems="center"
          color={selected ? 'lightGray' : 'transparent'}
          direction="row"
          display="flex"
          paddingX={6}
          paddingY={2}
        >
          <Box>
            <Icon color={selected ? 'darkGray' : 'gray'} icon="add" accessibilityLabel="" />
          </Box>
          <Box marginLeft={3}>
            <Text color={selected ? 'darkGray' : 'gray'} size="lg" weight="bold">
              {name}
            </Text>
          </Box>
        </Box>
      );
    }
  }
}
